// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"3cebf01b","453":"3edb3228"}[chunkId] + ".chunk.js";
};